<template>
  <div class="advisory-intro-3">
    <div class="content">
      <div class="top-section padding-horizontal-ml">
        <advisory-top-header @close="close" @back="back" variant="blue"/>
        <Stepper :current-step="2" :total-steps="stepsNumber"/>
        <div class="ri-title margin-top-ml">ייעוץ אישי ברייזאפ</div>
        <div class="ri-small-display margin-top-ml ri-alte-bold">
          <span class="pink">תוכנית שמסתכלת איתך קדימה</span>
        </div>
      </div>
      <div class="curly-container ri-large-body padding-ml padding-top-xl">
        <div class="text-container">
          <div class="item margin-bottom-l">
            <img class="margin-left-ml" src="/images/advisory/advisory-item-1.svg">
            <div>
              <span class="ri-font-weight-bold">בלחיצת כפתור</span>
              המערכת שלנו תאסוף בשבילך את כל החסכונות, הקופות, הקרנות והפקדונות שלך, כל הכסף והנכסים שנמצאים בבנק ומחוצה לו. מצידך? אפס מאמץ!
            </div>
          </div>
          <div class="item margin-bottom-l">
            <img class="margin-left-ml" src="/images/advisory/advisory-item-2.svg">
            <div>העבודה הקשה,
              <span class="ri-font-weight-bold"> עלינו</span>
              - אנחנו נבנה לך תכנית ברורה שתגשים את כל המטרות שלך.
            </div>
          </div>
          <div class="item margin-bottom-l">
            <img class="margin-left-ml" src="/images/advisory/advisory-item-3.svg">
            <div>לא רק דיבורים באוויר-
              <span class="ri-font-weight-bold">בפגישת זום אישית</span>
              נציג לך את התכנית וניתן לך צעדים פרקטיים כדי לצאת לדרך!
            </div>
          </div>
        </div>
        <riseup-button :action="next"
                       :size="'slim'"
                       title="סיקרנתם!"
                       :variant="'primary'"/>
      </div>
    </div>
  </div>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import Segment from '@/Segment';
import { mapGetters } from 'vuex';
import AdvisoryTopHeader from './AdvisoryTopHeader';

export default {
  name: 'AdvisoryIntro3',
  components: {
    Stepper: BaseUI.Stepper,
    RiseupButton: BaseUI.RiseupButton,
    AdvisoryTopHeader,
  },
  created() {
    Segment.trackUserGot('AdvisoryIntro3');
  },
  computed: {
    ...mapGetters('advisory', ['stepsNumber']),
  },
  methods: {
    next() {
      this.$emit('next');
    },
    back() {
      this.$emit('back');
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import '~@riseupil/base-ui/src/scss/spacings';
@import '~@riseupil/base-ui/src/scss/border-radius';

.advisory-intro-3 {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #142AA0;

  .content {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    text-align: start;
    color: $riseup_white;

    .pink {
      color: #F89BB4;
    }

    .top-section {
      flex: 3;
    }

    .curly-container {
      background: $riseup_beige;
      border-top-left-radius: 42px;
      border-top-right-radius: 42px;
      flex: 1;
      display: flex;
      flex-direction: column;

      .text-container {
        flex: 1;
        color: $riseup_black;
      }

      .item {
        display: flex;
        align-items: flex-start;
      }
    }
  }

  .extra {
    position: relative;

    .discount-image {
      position: absolute;
      left: 20px;
      bottom: -40px;
    }
  }

  .button {
    flex-shrink: 0;
  }
}
</style>
